export const settings = {
  debug: false,
  perf: false,
}
